module.exports = __webpack_public_path__ + "static/img/MIKE_HUSSEY.6ec0454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MIKE_HUSSEY.jpg
// module id = 5AlV
// module chunks = 0